import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import {Box, Text} from '@fuegokit/react'
import Placeholder from '../../../src/components/Placeholder'
import {PositionAwareItem, VerticalPositionProvider, RuleDetail, range} from '../../../src/components/RuleBuilder'

const ExampleBox = ({isSelected, onSelect, children, id, ...props}) => {
  // console.log(`isSelected in example box ${id}:`, isSelected)
  return (
    <StyledExampleBox onSelect={onSelect} isSelected={isSelected} {...props}>
      {children}
    </StyledExampleBox>
  )
}
const StyledExampleBox = styled(Box)`
  border: 1px dashed transparent;
  border-color: ${p => (p.isSelected ? 'deeppink' : 'transparent')};
`
const Content = ({index, ...rest}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 6,
        borderRadius: 2,
        backgroundColor: 'elevation.surface.sunken'
      }}
      {...rest}
    >
      <Text>Content and interactive elements that correspond to an element rendered in a step</Text>
    </Box>
  )
}

const StyledRuleDetailExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)
  useEffect(() => {
    setDomLoaded(true)
  }, [])
  return (
    <>
      {domLoaded && (
        <VerticalPositionProvider>
          <RuleDetail headerHeight={0} sx={{minHeight: '154px'}}>
            <Box sx={{minHeight: `100%`}} />
          </RuleDetail>
        </VerticalPositionProvider>
      )}
    </>
  )
}
export default StyledRuleDetailExample
